"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Palette = void 0;
const styles_1 = require("@material-ui/core/styles");
require("../assets/styles/_variables.scss");
const defaultTheme = styles_1.createMuiTheme();
exports.Palette = {
    palette: {
        primary: {
            light: '#2EA0DC',
            main: '#2EA0DC',
            dark: '#0e4a7c',
            contrastText: '#fff'
        },
        error: {
            light: '#FF0003',
            main: '#FF0003',
            dark: '#FF0003',
            contrastText: '#fff'
        },
        divider: '#E9E9F0',
        action: {
            active: '#E8E8ED',
            hover: '#AFAFB8',
            focused: '#2EA0DC'
        }
    },
};
//ToDo remove unnecessary overrides
exports.default = {
    overrides: {
        MuiContainer: {
            root: {
                [defaultTheme.breakpoints.up('sm')]: {
                    paddingLeft: '20px',
                    paddingRight: '20px'
                }
            }
        },
        MuiButton: {
            root: {
                fontSize: '.929rem',
                borderRadius: '8px',
                padding: '4px 16px 5px 16px',
                //height: '38px',
                minWidth: 'unset',
                "text-transform": "unset",
            },
            outlined: {
                padding: "4px 16px"
            },
            containedSizeLarge: {
                padding: "5px 16px 6px 16px",
                fontSize: '1rem'
            },
            containedSizeSmall: {
                padding: "3px 16px 4px 16px",
                fontSize: ".929rem",
            },
            outlinedSizeSmall: {
                fontSize: ".929rem",
            },
            outlinedSizeLarge: {
                padding: "6px 16px",
                fontSize: ".929rem"
            },
            containedPrimary: {
                borderRadius: '.571rem',
                backgroundColor: '#2EA0DC',
                '&:hover': {
                    backgroundColor: '#2EA0DC',
                    '@media (hover: none)': {
                        backgroundColor: '#2EA0DC',
                    },
                }
            },
            containedSecondary: {
                borderRadius: '.571rem',
                backgroundColor: '#3D4977',
                '&:hover': {
                    backgroundColor: '#3D4977!important',
                    '@media (hover: none)': {
                        backgroundColor: '#3D4977',
                    },
                }
            },
            outlinedSecondary: {
                color: "#3D4977",
                border: "1px solid rgba(61,73,119, 0.5)",
                '&:hover': {
                    border: "1px solid #3D4977",
                    backgroundColor: "rgba(61,73,119, 0.04)",
                    '@media (hover: none)': {
                        backgroundColor: 'rgba(61,73,119, 0.04)',
                    }
                }
            },
            iconSizeMedium: {
                "& > *:first-child": { fontSize: "1.72rem" }
            },
            endIcon: { marginLeft: "5px" },
            startIcon: { marginRight: "5px" },
        },
        MuiStepIcon: {
            root: {
                color: 'rgba(0, 0, 0, 0.54)',
                "&$active": {
                    color: '#2EA0DC'
                },
            }
        },
        MuiOutlinedInput: {
            root: {
                borderRadius: 6,
                fontSize: '14px',
                color: '#333333',
                fontFamily: 'HelveticaNeueCyr-Medium',
                '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(0,0,0,0.3)',
                },
                '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#FF0003!important'
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#2EA0DC!important',
                    borderWidth: '1px'
                },
            },
            notchedOutline: {
                borderRadius: 6,
                fontSize: '14px',
                color: '#333333',
                fontFamily: 'HelveticaNeuyeCyr, sans-serif',
                borderColor: 'rgba(0,0,0,0.3)',
                '&:hover': {
                    '.MuiOutlinedInput-notchedOutline': {
                        borderColor: '#AFAFB8',
                    },
                    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#FF0003!important'
                    }
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#2EA0DC',
                },
            },
        },
        MuiDialog: {
            paper: {
                margin: '18px',
                boxShadow: '0 5px 18px #0004074D',
                borderRadius: '6px'
            },
            paperWidthSm: {
                padding: '30px'
            }
        },
        MuiInputLabel: {
            root: {
                color: '#626264',
                fontFamily: 'HelveticaNeueCyr-Light',
                '&.Mui-focused': {
                    color: '#2EA0DC!important',
                }
            }
        },
        MuiFormLabel: {
            root: {
                color: '#333333',
                '&.Mui-error': {
                    color: '#333333'
                },
                '&.Mui-error.MuiInputLabel-shrink': {
                    color: '#FF0003!important'
                },
                '&.Mui-error.MuiInputLabel-shrink.Mui-focused': {
                    color: '#2EA0DC!important'
                },
            }
        },
        MuiCheckbox: {
            colorSecondary: {
                '&.Mui-checked': {
                    color: '#2EA0DC',
                    '&:hover': {
                        backgroundColor: 'rgba(46, 160, 220, 0.04)!important'
                    }
                },
                '&:hover': {
                    backgroundColor: 'rgba(46, 160, 220, 0.04)'
                }
            }
        },
        MuiAlert: {
            root: {
                borderRadius: '.571rem',
                fontSize: '1rem',
                [defaultTheme.breakpoints.down('sm')]: {
                    padding: '6px 8px'
                }
            },
            icon: {
                marginRight: '8px'
            },
            standardWarning: {
                backgroundColor: '#FDF1EA'
            }
        },
        MuiPaper: {
            rounded: {
                borderRadius: '10px',
            }
        },
        MuiTypography: {
            body1: {
                color: 'var(--grey-text)'
            }
        },
        MuiFormHelperText: {
            root: {
                '&.Mui-error': {
                    color: '#FF0003',
                    '&::first-letter': {
                        textTransform: 'capitalize'
                    }
                }
            }
        },
        MuiSkeleton: {
            root: {
                backgroundColor: '#F4F5FD'
            },
            pulse: {
                animation: undefined
            }
        },
        MuiSvgIcon: {
            root: {
                fontSize: '1.72rem'
            }
        },
        MuiInput: {
            underline: {
                '&:hover:not(.Mui-disabled)::before': {
                    borderBottom: '1px solid rgba(0, 0, 0, 0.42)'
                },
                '&.Mui-focused::after': {
                    borderBottom: '1px solid #2EA0DC;'
                },
                '&:after': {
                    borderBottom: '1px solid #2EA0DC;'
                }
            },
            input: {
                padding: '7px 20px',
                fontFamily: 'HelveticaNeueCyr-Medium',
                "&::placeholder": {
                    fontFamily: 'HelveticaNeueCyr-Light',
                    color: "#626264",
                    fontSize: '14px'
                }
            }
        },
        MuiSelect: {
            select: {
                '&:focus': { backgroundColor: 'unset' }
            }
        },
        MuiAutocomplete: {
            input: {
                '&:first-child': { padding: '7px 20px !important' }
            },
            inputRoot: {
                '&[class*="MuiInput-root"]': {
                    paddingBottom: '0'
                }
            },
            clearIndicator: {
                marginRight: '-30px'
            },
            clearIndicatorDirty: { display: 'none' },
            endAdornment: {
                top: 'calc(50% - 9px)',
                right: '15px'
            },
            listbox: {
                fontSize: '14px'
            },
            popupIndicator: {
                '& svg': {
                    width: '16px',
                    height: '9px',
                },
            },
        }
    }
};
